import { Series } from '@types';

const LUXE_CITY: Series = {
  id: 'luxe_city',
  name: 'Luxe in the City',
};

export default LUXE_CITY;
